import { Toro } from '../app/api/common/enumerations';
import { Constants } from '../app/core/constants';

export const environment = {
    production: true,
    defaultApiEndpoint: Toro.Environment.LXC,
    version: Constants.AppVersion,
    showEndpointInFooter: true,
};
